/** @jsxImportSource @emotion/react */
import React from 'react'
import { useParams } from 'react-router-dom'
import { OrderGrid } from '@components/systems'
import { useAppDispatch, useAppSelector, orderActions } from '@redux/index'

// NOTE: 간단히(좌-우 분할) 뷰 및 세로 탭은 임시 숨김 처리.
// 복구가 필요하면 이 파일의 git history 참고 (탭 전환 + OrderList/OrderDetail 구성).
//
// 라우트가 둘이다 — `/main/order`(목록) 와 `/main/order/:orderId`(상세). 그리는 것은 같고,
// 주소의 주문번호를 모달에 옮겨 적는 일만 여기서 한다. 즉 **모달의 열림/닫힘 정본은 URL** 이다.
const OrderPage = () => {
	// hook
	const { orderId } = useParams()

	// redux
	const reduxDispatch = useAppDispatch()
	const detailModalOrderId: string = useAppSelector(
		state => state.order.detailModalOrderId,
	)

	// URL → 모달. 주소에 번호가 없으면 닫는다(sessionStorage 에 남아 있던 옛 값도 여기서 씻긴다)
	React.useEffect(() => {
		const next: string = orderId ?? ''
		if (next !== detailModalOrderId) {
			reduxDispatch(orderActions.DETAIL_MODAL_ORDER_ID(next))
		}
	}, [orderId, detailModalOrderId, reduxDispatch])

	/*
		들어오면 목록을 **반드시 한 번** 읽는다.

		⚠ 전에는 `orderStatus === 'init'` 일 때만 읽었다. 그런데 이 상태는 sessionStorage 에 persist 되어
		지난 세션에서 한 번이라도 읽었으면 `'ok'` 로 되살아난다 — 그러면 조회를 건너뛰고, 한 번만 도는
		가드 때문에 다시 시도하지도 않아 **목록이 영영 비어 있었다**(2026-09-20 운영 사고).
		저장된 상태를 믿지 않고 화면에 들어온 사실만 믿는다.
	*/
	const didInit = React.useRef<boolean>(false)
	React.useEffect(() => {
		if (didInit.current) return
		didInit.current = true
		reduxDispatch(orderActions.TRIGGER_INIT_ORDER_PAGE(true))
	}, [reduxDispatch])

	return <OrderGrid />
}

export default OrderPage
